import { render, staticRenderFns } from "./SettingsInformation.vue?vue&type=template&id=40052880&scoped=true"
import script from "./SettingsInformation.vue?vue&type=script&lang=js"
export * from "./SettingsInformation.vue?vue&type=script&lang=js"
import style0 from "./SettingsInformation.vue?vue&type=style&index=0&id=40052880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40052880",
  null
  
)

export default component.exports